<template>
  <sameday-services-filter
    :params="{ services, ...params }"
    :search="search"
    v-slot="{ filteredServices }"
    @has:services="$emit('has:services', $event)"
  >
    <sameday-service
      v-for="(el, key) in filteredServices"
      :key="key"
      :params="{
        ...el,
        location: params,
      }"
      @on:form="$emit('on:form', $event)"
    ></sameday-service>
  </sameday-services-filter>
</template>

<script>
import SamedayServicesFilter from "@/components/Sameday/SamedayServicesFilter.vue";
import SamedayService from "@/components/Sameday/SamedayService.vue";

export default {
  components: {
    SamedayServicesFilter,
    SamedayService,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    search: {
      type: Object,
      default: () => {},
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
